<div class="homesick-container" *ngIf="orgCategories$ | async as categories">
  <div class="header">
    <span>Custom Homesick Days Per Category</span>
    <ng-container *ngIf="categories$ | async as allCategories">
      <button
        mat-flat-button
        color="accent"
        type="button"
        (click)="addCategory()"
        *ngIf="allCategories.length > categories.length"
      >
        Add Category
      </button>
    </ng-container>
  </div>
  <div class="list">
    <div *ngFor="let category of categories; let i = index" class="list-item">
      <div class="item-content">
        <span>{{ category.name }}</span>
        <div>
          <span>
            {{ category.length }} day<span *ngIf="category.length > 1">s</span>
          </span>
          <mat-icon class="delete" (click)="removeCategory(i)"
            >delete_outline</mat-icon
          >
        </div>
      </div>
      <mat-divider></mat-divider>
    </div>
  </div>
</div>
